module.exports = __webpack_public_path__ + "static/img/home06.71164dcb.png";